import { render, staticRenderFns } from "./AsignacionAuditoria.vue?vue&type=template&id=1a48ee6a&"
import script from "./AsignacionAuditoria.vue?vue&type=script&lang=js&"
export * from "./AsignacionAuditoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports